export const LOW_INVENTORY_REQUEST = 'LOW_INVENTORY_REQUEST'
export const LOW_INVENTORY_SUCCESS = 'LOW_INVENTORY_SUCCESS'
export const LOW_INVENTORY_FAIL = 'LOW_INVENTORY_FAIL'
export const LOW_INVENTORY_RESET = 'LOW_INVENTORY_RESET'

export const INVENTORY_MFG_REQUEST = 'INVENTORY_MFG_REQUEST'
export const INVENTORY_MFG_SUCCESS = 'INVENTORY_MFG_SUCCESS'
export const INVENTORY_MFG_FAIL = 'INVENTORY_MFG_FAIL'
export const INVENTORY_MFG_RESET = 'INVENTORY_MFG_RESET'

export const INVENTORY_SUMMARY_REQUEST = 'INVENTORY_SUMMARY_REQUEST'
export const INVENTORY_SUMMARY_SUCCESS = 'INVENTORY_SUMMARY_SUCCESS'
export const INVENTORY_SUMMARY_FAIL = 'INVENTORY_SUMMARY_FAIL'
export const INVENTORY_SUMMARY_RESET = 'INVENTORY_SUMMARY_RESET'

export const SALES_REPORT_REQUEST = 'SALES_REPORT_REQUEST'
export const SALES_REPORT_SUCCESS = 'SALES_REPORT_SUCCESS'
export const SALES_REPORT_FAIL = 'SALES_REPORT_FAIL'

export const SALES_LIST_REQUEST = 'SALES_LIST_REQUEST'
export const SALES_LIST_SUCCESS = 'SALES_LIST_SUCCESS'
export const SALES_LIST_FAIL = 'SALES_LIST_FAIL'

export const STOCK_MOVEMENTS_REQUEST = 'STOCK_MOVEMENTS_REQUEST'
export const STOCK_MOVEMENTS_SUCCESS = 'STOCK_MOVEMENTS_SUCCESS'
export const STOCK_MOVEMENTS_FAIL = 'STOCK_MOVEMENTS_FAIL'
